// src/components/Contactus.jsx
import React, { useEffect, useState } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import "./Contactus.css";


const API_BASE =
    process.env.REACT_APP_API_BASE ||
    (process.env.NODE_ENV === "production" ? "" : "http://localhost:5000");

const PUBLIC = process.env.PUBLIC_URL || "";

export default function Contactus() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });
    const [sending, setSending] = useState(false);
    const [okMsg, setOkMsg] = useState("");
    const [errMsg, setErrMsg] = useState("");

    useEffect(() => {
        if (!okMsg && !errMsg) return undefined;
        const timer = setTimeout(() => {
            setOkMsg("");
            setErrMsg("");
        }, 3000);

        return () => clearTimeout(timer);
    }, [okMsg, errMsg]);

    const onChange = (e) => {
        const { name, value } = e.target;
        setForm((f) => ({ ...f, [name]: value }));
    };

    const validate = () => {
        if (!form.name.trim()) return "Please enter your name.";
        if (!form.email.trim()) return "Please enter your email.";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()))
            return "Please enter a valid email address.";
        if (!form.message.trim()) return "Please enter a message.";
        return "";
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setOkMsg("");
        setErrMsg("");

        const v = validate();
        if (v) return setErrMsg(v);

        try {
            setSending(true);
            const res = await fetch(`${API_BASE}/send-email`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: form.name.trim(),
                    email: form.email.trim(),
                    phone: form.phone.trim(),
                    message: form.message.trim(),
                }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok || !data?.success) {
                throw new Error(data?.error || `Send failed (${res.status})`);
            }
            setOkMsg("Thanks! Your message has been sent.");
            setForm({ name: "", email: "", phone: "", message: "" });
        } catch (err) {
            setErrMsg(err.message || "Sorry, something went wrong.");
        } finally {
            setSending(false);
        }
    };

    return (
        <section
            id="contact"
            className="contact-container"
            style={{
                "--contact-bg": `url("${PUBLIC}/larawan/TGPBGMapD.png")`,
                "--contact-mobile-bg": `url("${PUBLIC}/larawan/TGPBGMapM.png")`,
            }}
        >
            <h2 className="contact-title">Contact Us</h2>
            <div className="contact-underline" />

            <form className="contact-form" onSubmit={onSubmit} noValidate>
                <div className="contact-row">
                    <input
                        name="name"
                        placeholder="Full Name"
                        value={form.name}
                        onChange={onChange}
                        disabled={sending}
                        required
                    />
                    <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={onChange}
                        disabled={sending}
                        required
                    />
                </div>

                <div className="contact-row">
                    <input
                        name="phone"
                        placeholder="Phone (optional)"
                        value={form.phone}
                        onChange={onChange}
                        disabled={sending}
                    />
                </div>

                <div className="contact-row">
                    <textarea
                        name="message"
                        rows={5}
                        placeholder="Your message…"
                        value={form.message}
                        onChange={onChange}
                        disabled={sending}
                        required
                    />
                </div>

                {okMsg && <div className="thank-you-message">{okMsg}</div>}
                {errMsg && (
                    <div
                        style={{
                            padding: 12,
                            marginTop: 8,
                            borderRadius: 10,
                            background: "#3f1010",
                            color: "#f5b8b8",
                            border: "1px solid #7b1f1f",
                        }}
                    >
                        {errMsg}
                    </div>
                )}

                <button className="contact-submit" type="submit" disabled={sending}>
                    {sending ? "Sending…" : "Send Message"}
                </button>
            </form>

            {/* Optional invite box that matches your CSS */}
            <div className="invitation-box">
                Let’s connect. Triskelion members are always welcome to reach out and connect with us.
                If you have any questions, feel free to send us a message—we’ll get back to you shortly.
            </div>

            <div className="social-links">
                <a href="https://www.facebook.com/CanadaNationalCouncil.TauGammaPhi.TauGammaSigma" target="_blank" rel="noopener noreferrer">
                    <FaFacebook className="social-icon" />
                </a>
                <a href="https://instagram.com/taugammaphifraternity?igsh=bXNtZm84ZW04N3hh" target="_blank" rel="noopener noreferrer">
                    <FaInstagram className="social-icon" />
                </a>
            </div>

        </section>
    );
}
